import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { EpcMembership } from "./EpcMembership/EpcMembership";
import { EPCRenewal } from "./EPCRenewal/EPCRenewal";
import { ForgotPassword } from "./ForgotPassword/ForgotPassword";
import { IconContent } from "./Icons/IconContent";
import { OneTimePassword } from "./OneTimePassword/OneTimePassword";
import { ProductReview } from "./ProductReview/ProductReview";
import { Registration } from "./Registration/Registration";
import { ResetPassword } from "./ResetPassword/ResetPassword";
import { SignUp } from "./SignUp/SignUp";
import { UserProfile } from "./UserProfile/UserProfile";

export const Contents = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(() => {
    if (approveId) {
      return;
    }
    const activeTab = query.get("activeTab");
    if (!activeTab) {
      navigate(`/dedicated/eraman/contents?activeTab=eramanSignIn`, {
        replace: true,
      });
    }
  }, [query.get("activeTab")]);

  const items = [
    {
      label: "Sign In",
      key: "eramanSignIn",
      children: <SignUp />,
    },
    {
      label: "Forgot Password",
      key: "eramanForgotPassword",
      children: <ForgotPassword />,
    },
    {
      label: "Reset Password",
      key: "eramanResetPassword",
      children: <ResetPassword />,
    },
    {
      label: "Registration",
      key: "eramanRegistration",
      children: <Registration />,
    },
    {
      label: "Icons",
      key: "eramanIcons",
      children: <IconContent />,
    },
    {
      label: "OTP",
      key: "eramanOTP",
      children: <OneTimePassword />,
    },
    {
      label: "EPC Membership",
      key: "epcMembership",
      children: <EpcMembership />,
    },
    {
      label: "EPC Renewal",
      key: "epcRenewal",
      children: <EPCRenewal />,
    },
    {
      label: "Profile",
      key: "eramanUserProfile",
      children: <UserProfile />,
    },
    {
      label: "Product Review",
      key: "eramanProductReview",
      children: <ProductReview />,
    },
  ];

  const handleProductManagement = (activeTab: any) => {
    if (activeTab === "awards") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/awards/awardsList/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Award
        </Button>
      );
    } else if (activeTab === "news") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/news/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New News
        </Button>
      );
    } else if (activeTab === "dutyFreeBuyingGuide") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/travellersInfo/dutyFreeBuyingGuide/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Duty Free Buying Guide
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Contents"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleProductManagement(query.get("subActiveTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
